export const config = {
	card: {
		class: 'pa-6'
	},
	cardTitle: {
		class: 'd-flex align-start flex-nowrap pa-0 mb-6'
	},
	closeBtn: {
		icon: true,
		width: '32px',
		height: '32px',
		class: 'mt-n2 mr-n2 ml-4'
	},
	actionsCtn: {
		class: 'd-flex flex-wrap mt-6'
	},
	cancelBtn: {
		color: 'primary',
		text: true
	},
	confirmBtn: {
		color: 'primary',
		class: 'ml-4'
	}
};
